/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { TitelDisplayModel as AceXFoundPortalCoreCaqModelsTitelDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/titel-display-model';
import { TitelType as AceXFoundPortalCoreEntitiesTitelType } from '../models/ace/xFound/Portal/Core/Entities/titel-type';

@Injectable({
providedIn: 'root',
})

export class TitelService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiTitelGet
   */
  static readonly ApiTitelGetPath = '/api/Titel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTitelGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTitelGet$Plain$Response(params?: {

    /**
     * 0 &#x3D; Praefix
     * 
     * 1 &#x3D; Postfix
     * 
     * 2 &#x3D; All
     */
    titelType?: AceXFoundPortalCoreEntitiesTitelType;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsTitelDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, TitelService.ApiTitelGetPath, 'get');
    if (params) {
      rb.query('titelType', params.titelType, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsTitelDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTitelGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTitelGet$Plain(params?: {

    /**
     * 0 &#x3D; Praefix
     * 
     * 1 &#x3D; Postfix
     * 
     * 2 &#x3D; All
     */
    titelType?: AceXFoundPortalCoreEntitiesTitelType;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsTitelDisplayModel>> {

    return this.apiTitelGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsTitelDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsTitelDisplayModel>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTitelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTitelGet$Response(params?: {

    /**
     * 0 &#x3D; Praefix
     * 
     * 1 &#x3D; Postfix
     * 
     * 2 &#x3D; All
     */
    titelType?: AceXFoundPortalCoreEntitiesTitelType;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsTitelDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, TitelService.ApiTitelGetPath, 'get');
    if (params) {
      rb.query('titelType', params.titelType, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsTitelDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTitelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTitelGet(params?: {

    /**
     * 0 &#x3D; Praefix
     * 
     * 1 &#x3D; Postfix
     * 
     * 2 &#x3D; All
     */
    titelType?: AceXFoundPortalCoreEntitiesTitelType;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsTitelDisplayModel>> {

    return this.apiTitelGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsTitelDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsTitelDisplayModel>)
    );
  }

}